import Vue from 'vue'
import Router from 'vue-router'
import CommonProblem from '@/components/CommonProblem'
import Detail from '@/components/Detail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    
    {
      path: '/commonProblem.html',
      name: 'CommonProblem',
      component: CommonProblem,
      meta:{
        title: '常见问题'
      }
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail,
      meta:{
        title: '常见问题'
      }
    }
  ],
  base: '/FAQ'
})



// WEBPACK FOOTER //
// ./src/router/index.js